import { FC, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import cn from 'bem-cn';

import { useGetLeaderboardTopQuery, useGetUserByPublicIdQuery } from '../../../store';

import { Stack } from '../../../components/UI';
import { Leaderboard } from '../../../components/Leaderboard/Leaderboard';

import './ProfileRating.scss';

const b = cn('profile-rating');

export const ProfileRating: FC = () => {
    const { publicId } = useParams<{ publicId: string }>();
    const { data: user } = useGetUserByPublicIdQuery({ publicId: publicId || '' }, { skip: !publicId });
    const { data: leaders } = useGetLeaderboardTopQuery();

    const getLeadersWithUser = useMemo(() => {
        return leaders || [];
    }, [leaders]);

    if (!user) {
        return null;
    }

    return (
        <Stack className={b()} spacing={24}>
            <Stack direction="row" justifyContent="space-between" align-items="center" className={b('header')}>
                <h2>Топ 100 лидеров</h2>
            </Stack>
            <Leaderboard leaders={getLeadersWithUser} currentUserPublicId={user?.publicId} />
        </Stack>
    );
};
